import { Divider, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomSwitch from "../../../components/CustomSwitch";
import {
  createBranchDataSharing,
  getBranchesDataSharing,
  updateBranchDataSharing,
} from "../../../redux/reducers/clinicSlice";

const initValues = { petData: false, vetData: false, inventryData: false };

const BranchSettings = () => {
  const dispatch = useDispatch();
  const [values, setValues] = useState(initValues);
  const { branchesDataSharing } = useSelector((state) => state?.clinic);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);

  useEffect(() => {
    onApiCall();
  }, []);

  useEffect(() => {
    const matchedRecord = recMatchedWithCurrUser() ?? null;
    if (matchedRecord) {
      setValues({
        petData: matchedRecord?.petData,
        vetData: matchedRecord?.vetData,
        inventryData: matchedRecord?.inventryData,
      });
    }
  }, [branchesDataSharing]);

  const onApiCall = () => dispatch(getBranchesDataSharing());

  const recMatchedWithCurrUser = () => {
    if (!branchesDataSharing || branchesDataSharing?.length === 0) return null;
    const matchedRec = (branchesDataSharing ?? [])?.find(
      (li) => li?.createdBy === profile?.id,
    );
    return matchedRec ? matchedRec : branchesDataSharing?.[0];
  };

  const onChangeSwitchValues = (name, value) => {
    setValues({ ...values, [name]: value });
  };

  const onSaveChanges = () => {
    const matchedRecord = recMatchedWithCurrUser() ?? null;
    const reqObj = { data: values };
    if (matchedRecord) {
      reqObj.id = matchedRecord?.shareId;
    }
    dispatch(
      matchedRecord
        ? updateBranchDataSharing(reqObj)
        : createBranchDataSharing(reqObj),
    ).then((res) => {
      if (res?.payload) onApiCall();
    });
  };

  return (
    <div>
      <div className="mh20">
        <Typography className="fs18 font-bold black">
          Branch Management
        </Typography>
        <Typography className="fs12 txt-regular gray4">
          Adjust your settings for multiple branches.
        </Typography>
        <div className="mv10">
          <Divider />
        </div>
        <Typography className="fs16 font-bold black">Data Sharing</Typography>
        <Typography className="fs12 txt-regular gray4">
          Control how data ias shared between your clinic's branches. Enable or
          disable sharing for pets, vets, and inventory.
        </Typography>
        <div className="gray-brder mt10">
          <div className="flex-row-ali-cen">
            <div className="w80Per">
              <Typography className="fs16 txt-semi-bold blue-color">
                Pets Data
              </Typography>
            </div>
            <div className="w20Per flex1-end">
              <div className="flex-row-ali-cen">
                <div className="flex-row-ali-cen mt5">
                  <CustomSwitch
                    value={values?.petData}
                    onChange={(e) =>
                      onChangeSwitchValues("petData", !values?.petData)
                    }
                    grayToBlue
                  />
                </div>
                <div className="ml10">
                  <Typography
                    className={`white-color fs12 con-fit ${values?.petData ? "card-con-blue-back" : "card-con-gray-back"} ph10 br5`}
                  >
                    {values?.petData ? "On" : "Off"}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          <Typography className="fs12 txt-regular black">
            Allow pet data to be shared across all branches.
          </Typography>
          <div className="mv10">
            <Divider />
          </div>
          <div className="flex-row-ali-cen">
            <div className="w80Per">
              <Typography className="fs16 txt-semi-bold blue-color">
                Vets Data
              </Typography>
            </div>
            <div className="w20Per flex1-end">
              <div className="flex-row-ali-cen">
                <div className="flex-row-ali-cen mt5">
                  <CustomSwitch
                    value={values?.vetData}
                    onChange={(e) =>
                      onChangeSwitchValues("vetData", !values?.vetData)
                    }
                    grayToBlue
                  />
                </div>
                <div className="ml10">
                  <Typography
                    className={`white-color fs12 con-fit ${values?.vetData ? "card-con-blue-back" : "card-con-gray-back"} ph10 br5`}
                  >
                    {values?.vetData ? "On" : "Off"}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          <Typography className="fs12 txt-regular black">
            Allow vet data to be shared across all branches.
          </Typography>
          <div className="mv10">
            <Divider />
          </div>
          <div className="flex-row-ali-cen">
            <div className="w80Per">
              <Typography className="fs16 txt-semi-bold blue-color">
                Inventory Data
              </Typography>
            </div>
            <div className="w20Per flex1-end">
              <div className="flex-row-ali-cen">
                <div className="flex-row-ali-cen mt5">
                  <CustomSwitch
                    value={values?.inventryData}
                    onChange={(e) =>
                      onChangeSwitchValues(
                        "inventryData",
                        !values?.inventryData,
                      )
                    }
                    grayToBlue
                  />
                </div>
                <div className="ml10">
                  <Typography
                    className={`white-color fs12 con-fit ${values?.inventryData ? "card-con-blue-back" : "card-con-gray-back"} ph10 br5`}
                  >
                    {values?.inventryData ? "On" : "Off"}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
          <Typography className="fs12 txt-regular black">
            Allow inventory - stock and services data to be shared across all
            branches.
          </Typography>
          <div className="flex1-end mt10">
            <div>
              <CustomButton text="Save" smallBtn onClick={onSaveChanges} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchSettings;
